import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { createSafeContext } from "@coveord/plasma-mantine";
var ref = _sliced_to_array(createSafeContext("TopBar component was not found in tree"), 2);
export var TopBarProvider = ref[0], useTopBarContext = ref[1];

//# sourceMappingURL=TopBarContext.js.map